const MOBILE_VIEWPORT = 768;

// noinspection JSUnusedGlobalSymbols
export default MOBILE_VIEWPORT;
